<template>
  <div class="tools-hover-box-container" @click.stop.prevent="clickFilter">
      <section class="tools-hover-box-item" v-for="({ name, list }, i) in configList" :key="i">
          <span class="tools-hover-box-category">{{ name }}</span>
          <div class="tools-hover-box-list">
              <div
                  class="tools-hover-box-list-item"
                  data-hoverflag="true"
                  v-for="(t, j) in list"
                  :key="j"
                  @click.prevent="gotoRouter(t)"
              >
                  <icon-svg class="item-icon-size" :icon-class="t.icon" />
                  <p class="item-title">{{ t.title }}</p>
              </div>
          </div>
      </section>
  </div>
</template>

<script>
import UtilCache from '@dap/shared-utils/cache';
import config from './cardsList.js';

export default {
  name: 'ToolsHoverBox',
  components: {},
  props: {
    configList: {
      type: [],
      default: () => [],
    },
  },
  data () {
      return {
          // 抽出一个 cardsList.json 配置文件
          cardsList: [],
      };
  },
  computed: {
  },
 methods: {
      clickFilter (e) {
          const { hoverflag: hoverFlag } = e.target.dataset;
          // ignore
          // e.prevntDefault();
          // e.stopPropagation();
      },
      gotoRouter (t) {
          // 最近点击工具缓存，首页展示用
          const toolsCache = UtilCache.getCacheWithChain('filter.home.tools') || [];
          const tIndex = toolsCache.findIndex((i) => i.routerName === t.routerName);
          if (tIndex >= 0) {
              toolsCache.splice(tIndex, 1);
          }
          toolsCache.unshift(t);
          UtilCache.setCacheWithChain('filter.home.tools', toolsCache.slice(0, 6));

        const { routePath, routerName, params = {}, openInCurrent = false, linkFn } = t;
        if (routePath && openInCurrent) {
          // 在当前页面打开
          this.$router.push({
            path: routePath,
            params
          });
        }
        if (routePath && !openInCurrent) {
          const { href } = this.$router.resolve({
            path: routePath,
            params
          });
          window.open(href, '_blank');
        }
        if (linkFn) {
          // 外部链接
          window.open(linkFn(), '_blank');
        }
        if (openInCurrent) {
          // 在当前页面打开
          this.$router.push({
            name: routerName,
            params
          });
        }
      },
  },
};
</script>

<style lang="scss">
.tools-hover-box-item {
  pointer-events: none;
  user-select: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 230px;
  padding-top: 30px;
  padding-bottom: 31px;
  padding-left: 40px;
  .tools-hover-box-category {
      display: inline-block;
      min-width: 72px;
      width: 100%;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #303133;
      line-height: 25px;
  }
  .tools-hover-box-list {
      flex-shrink: 0;
      overflow: hidden;
      box-sizing: border-box;
      display: inline-grid;
      grid-auto-flow: column;
      grid-template-rows: repeat(4, minmax(25%, 1fr));
      margin-top: 6px;
      .tools-hover-box-list-item {
          pointer-events: auto;
          box-sizing: border-box;
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          //width: 140px;
          margin-top: 14px;
          .item-icon-size {
              display: inline-block;
              width: 16px;
              height: 16px;
              margin-right: 10px;
          }
          .item-title {
              width: 100px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #303133;
              line-height: 20px;
              cursor: pointer;
              &:hover {
                  color: #17e0b5;
              }
          }
      }
  }
}
</style>
